import React from "react";
import { Typography, Box } from "@mui/material";
import { NavLink } from "react-router-dom";
import SecondaryButton from "../components/secondaryButton";
import { CiDeliveryTruck } from "react-icons/ci";
import CartContents from "../components/cartContents";

export default function Cart() {
  return (
    <>
      <Box paddingX={4}>
        <NavLink to="/products">
          <SecondaryButton val={"Back to the products"} />
        </NavLink>
      </Box>
      <Box textAlign={"center"}>
        <Typography variant="overline" component="div" sx={{ m: 3 }}>
          <CiDeliveryTruck size={20}/>
            Spring offer: Free delivery on all orders
          <CiDeliveryTruck size={20}/>
        </Typography>
      </Box>
      <CartContents />
    </>
  );
}
